<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e1467748" style="color: #82a339"><b>PROSCIUTTO WITH MELON</b></p>
<p class="ext" id="d7e1468248"><b><i>The marriage of sweet ripe melon and salty prosciutto is a classic combination. Imported prosciutto di Parma, available at Italian grocers and specialty food markets, is much milder than the domestic varieties of this ham. It’s worth seeking out.</i></b></p>
<p class="h4" id="d7e1470448" style="color: #496210"><b>Prep: 10 minutes</b></p>
<p class="ul" id="d7e1470948">1 small honeydew melon or 1medium <br/> cantaloupe, chilled</p>
<p class="ul" id="d7e1471548">4 ounces prosciutto, thinly sliced <br/> freshly ground black pepper</p>
<p class="pub" id="d7e1472348" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> Cut melon in half through stem end and remove seeds. Cut each half into 4 wedges; cut off rind.</p>
<p class="pub" id="d7e1473348"><span style="color: #c15b49"><b>2.</b></span> Arrange 2 melon wedges on each of four plates; arrange prosciutto to side of melon. Sprinkle pepper on each serving. Makes 4 first-course servings.</p>
<p class="ntx" id="d7e1475048">Each serving: About 150 calories, 9g protein, 22g carbohydrate, 4g total fat (1g saturated), 23mg cholesterol, 548mg sodium.</p>
<p class="h4l" id="d7e1476048" style="color: #496210"><b>PROSCIUTTO WITH OTHER FRUIT</b></p>
<p class="tx4" id="d7e1476548">Prepare as directed but substitute <b>8 large green or black figs, </b>each cut in half, or <b>2 medium papayas, </b>peeled, seeded, and sliced, for melon.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c42_r1.vue?6ae6efc6